import { EyeFilled, FileTextOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';
import Flag from 'react-flagpack';

import { Button, ErrorBoundary } from '../../../../../components/index';
import { DockingWasteCollectionItemType } from '../../../../../services/wasteCollectionApi';
import { createDateStringPtBr } from '../../../../../utils/utils';
import { WasteCollectionStatusTag } from '../WasteCollectionStatusTag';

export function isWasteCollectionSent(docking: {
  sent_has_waste_collection?: boolean | null;
}) {
  return (
    docking.sent_has_waste_collection !== null &&
    docking.sent_has_waste_collection !== undefined
  );
}

export function columns(
  onOpenDrawer: (docking: DockingWasteCollectionItemType) => void
): ColumnsType<Record<string, any>> {
  return [
    {
      title: 'atracação',
      dataIndex: 'docking_code',
      width: '14%',
      sorter: {
        compare: (a: any, b: any) =>
          (a.docking_code || '').localeCompare(b.docking_code || ''),
        multiple: 1,
      },
    },
    {
      title: 'embarcação',
      dataIndex: 'vessel_flag',
      width: '24%',
      sorter: {
        compare: (a: any, b: any) =>
          (a.vessel_name || '').localeCompare(b.vessel_name || ''),
        multiple: 1,
      },
      render: (value, record) => {
        return (
          <div style={{ display: 'flex', gap: '4px' }}>
            <div style={{ width: '20px' }}>
              {value && (
                <ErrorBoundary replace="">
                  <Flag code={value} size="m" />
                </ErrorBoundary>
              )}
            </div>
            <span
              style={{
                textTransform: 'capitalize',
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
              }}
            >
              {record.vessel_name?.toLowerCase() || ''}
            </span>
          </div>
        );
      },
    },
    {
      title: 'berço',
      dataIndex: 'docking_place_name',
      width: '16%',
      sorter: {
        compare: (a: any, b: any) =>
          (a.docking_place_name || '').localeCompare(
            b.docking_place_name || ''
          ),
        multiple: 1,
      },
    },
    {
      title: 'desatracação',
      dataIndex: 'last_cable_untied_in',
      width: '14%',
      sorter: {
        compare: (a: any, b: any) =>
          (a.last_cable_untied_in || '').localeCompare(
            b.last_cable_untied_in || ''
          ),
        multiple: 1,
      },
      render: (value) => (value ? createDateStringPtBr(value) : ''),
    },
    {
      title: 'coleta de resíduo',
      dataIndex: 'has_waste_collection',
      width: '12%',
      render: (value) => (
        <WasteCollectionStatusTag hasWasteCollection={value} />
      ),
    },
    {
      title: 'status xml',
      dataIndex: 'last_date_xml',
      width: '14%',
      sorter: {
        compare: (a: any, b: any) =>
          (a.last_date_xml || '').localeCompare(b.last_date_xml || ''),
        multiple: 1,
      },
      render: (value) =>
        value ? (
          createDateStringPtBr(value)
        ) : (
          <div>
            <FileTextOutlined style={{ color: 'var(--neutral_medium)' }} />
            <i style={{ color: 'var(--neutral_medium)', marginLeft: '5px' }}>
              Ainda não gerado
            </i>
          </div>
        ),
    },
    {
      title: '',
      width: '6%',
      align: 'right' as const,
      render: (_, record) => (
        <Button
          icon={<EyeFilled />}
          onClick={() => onOpenDrawer(record as DockingWasteCollectionItemType)}
        />
      ),
    },
  ];
}
